import { Center, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import BlueTopPage from '../BlueTopPage';
import CustomButton from '@/components/atoms/CustomButton';

const NotFoundPage = () => {
  return (
    <BlueTopPage title="Oops!" description="404 page not found.">
      <Center maxWidth={{ md: '350px', lg: '450px' }}>
        <VStack gap={'20px'}>
          <Text variant={'urbanistSemiBold'} textAlign={'center'}>
            Check that you type the address correctly, go back to your previous page or try using our site search to
            find something specific.
          </Text>
          <CustomButton label="Go Back" onClick={() => window.history.back()} width={'150px'} />
        </VStack>
      </Center>
    </BlueTopPage>
  );
};

export default NotFoundPage;
